<template>
  <div class="row" style="padding-top:20px;">
      <data-card v-for="item in data" :data="item"></data-card>
      <div
  </div>
</template>
<script>
import DataCard from '@/components/Home/Class/DataCard.vue';
export default {
  name: "Home",
  components: {
      "data-card":DataCard,
  },
  computed: {
      data()
      {
          return this.$store.getters.classes;
      },
      
  }
  
};
</script>
<style lang="scss" scoped>

// 
</style>